import { render } from "./PackageOrderGeneratorAssistant.vue?vue&type=template&id=2113f978&scoped=true"
import script from "./PackageOrderGeneratorAssistant.vue?vue&type=script&lang=js"
export * from "./PackageOrderGeneratorAssistant.vue?vue&type=script&lang=js"

import "./PackageOrderGeneratorAssistant.vue?vue&type=style&index=0&id=2113f978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2113f978"]])

export default __exports__